import { defineMessages } from 'react-intl';

export const paymentsMessages = defineMessages({
    payment: {
        id: 'payment',
        defaultMessage: 'Payment',
    },
    payments: {
        id: 'payments',
        defaultMessage: 'Payments',
    },
    timestamp: {
        id: 'timestamp',
        defaultMessage: 'Timestamp',
    },
    paymentType: {
        id: 'payment-type',
        defaultMessage: 'Payment type',
    },
    amountWithTax: {
        id: 'amount-with-tax',
        defaultMessage: 'Amount with tax',
    },
    receiptNumber: {
        id: 'receipt-number',
        defaultMessage: 'Receipt #',
    },
    paymentOn: {
        id: 'payment-on',
        defaultMessage: 'Payment on',
    },
    cash: {
        id: 'cash',
        defaultMessage: 'Cash',
    },
    card: {
        id: 'card',
        defaultMessage: 'Card',
    },
    online: {
        id: 'online',
        defaultMessage: 'Online',
    },
    bank: {
        id: 'bank',
        defaultMessage: 'Bank',
    },
    paidOn: {
        id: 'paid-on',
        defaultMessage: 'Paid on',
    },
    amount: {
        id: 'amount',
        defaultMessage: 'Amount',
    },
    taxAmount: {
        id: 'tax-amount',
        defaultMessage: 'Tax amount',
    },
    operator: {
        id: 'operator',
        defaultMessage: 'Operator',
    },
    downloadReceipt: {
        id: 'download-receipt',
        defaultMessage: 'Download receipt',
    },
    serviceType: {
        id: 'service-type',
        defaultMessage: 'Service type',
    },
    parking: {
        id: 'parking',
        defaultMessage: 'Parking',
    },
    payStation: {
        id: 'payStation',
        defaultMessage: 'Pay-station',
    },
    visitor: {
        id: 'visitor',
        defaultMessage: 'Visitor',
    },
    serviceColumnTitle: {
        id: 'service-column-title',
        defaultMessage: 'Service',
    },
    stayCashPayment: {
        id: 'stay-cash-payment',
        defaultMessage: 'Stay cash payment',
    },
    stayCardPayment: {
        id: 'stay-card-payment',
        defaultMessage: 'Stay card payment',
    },
    manualAccept: {
        id: 'manual-accept',
        defaultMessage: 'Manual accept',
    },
    manualDispense: {
        id: 'manual-dispense',
        defaultMessage: 'Manual dispense',
    },
    synchronisation: {
        id: 'synchronisation',
        defaultMessage: 'Synchronisation',
    },
    clear: {
        id: 'clear',
        defaultMessage: 'Clear',
    },
    emptyRecycleBoxes: {
        id: 'empty-recycle-boxes',
        defaultMessage: 'Empty recycle boxes',
    },
    date: {
        id: 'date',
        defaultMessage: 'Date',
    },
    reference: {
        id: 'reference',
        defaultMessage: 'Reference',
    },
    type: {
        id: 'type',
        defaultMessage: 'Type',
    },
    stage: {
        id: 'stage',
        defaultMessage: 'Stage',
    },
    status: {
        id: 'status',
        defaultMessage: 'Status',
    },
    stay: {
        id: 'stay',
        defaultMessage: 'Stay',
    },
    requestedAmount: {
        id: 'requested-amount',
        defaultMessage: 'Requested amount',
    },
    currency: {
        id: 'currency',
        defaultMessage: 'Currency',
    },
    deviceType: {
        id: 'device-type',
        defaultMessage: 'Device type',
    },
    successful: {
        id: 'successful',
        defaultMessage: 'Successful',
    },
    pending: {
        id: 'pending',
        defaultMessage: 'Pending',
    },
    error: {
        id: 'error',
        defaultMessage: 'Error',
    },
    canceled: {
        id: 'canceled',
        defaultMessage: 'Canceled',
    },
    completed: {
        id: 'completed',
        defaultMessage: 'Completed',
    },
    clearing: {
        id: 'clearing',
        defaultMessage: 'Clearing',
    },
    insertingAmount: {
        id: 'inserting-amount',
        defaultMessage: 'Inserting amount',
    },
    insertingAmountCompleted: {
        id: 'inserting-amount-completed',
        defaultMessage: 'Inserting amount completed',
    },
    insertingAmountCanceled: {
        id: 'inserting-amount-canceled',
        defaultMessage: 'Inserting amount canceled',
    },
    successfulCardTransaction: {
        id: 'successful-card-transaction',
        defaultMessage: 'Successful card transaction',
    },
    failedCardTransaction: {
        id: 'failed-card-transaction',
        defaultMessage: 'Failed card transaction',
    },
    synchronising: {
        id: 'synchronising',
        defaultMessage: 'Synchronising',
    },
    reversedCardTransaction: {
        id: 'reversed-card-transaction',
        defaultMessage: 'Reversed card transaction',
    },
    failedReversedCardTransaction: {
        id: 'failed-reversed-card-transaction',
        defaultMessage: 'Failed-reversed-card-transaction',
    },
    canceledCardTransaction: {
        id: 'canceled-card-transaction',
        defaultMessage: 'Canceled card transaction',
    },
    issuingFiscalNote: {
        id: 'issuing-fiscal-note',
        defaultMessage: 'Issuing fiscal note',
    },
    issuingFiscalNoteCompleted: {
        id: 'issuing-fiscal-note-completed',
        defaultMessage: 'Issuing fiscal note completed',
    },
    dispensingAmount: {
        id: 'dispensing-amount',
        defaultMessage: 'Dispensing amount',
    },
    banknoteValidator: {
        id: 'banknote-validator',
        defaultMessage: 'Banknote validator',
    },
    coinSelector: {
        id: 'coin-selector',
        defaultMessage: 'Coin selector',
    },
    operation: {
        id: 'operation',
        defaultMessage: 'Operation',
    },
    operations: {
        id: 'operations',
        defaultMessage: 'Operations',
    },
    category: {
        id: 'category',
        defaultMessage: 'Category',
    },
    receivedFrom: {
        id: 'received-from',
        defaultMessage: 'Received from',
    },
    eventLog: {
        id: 'event-log',
        defaultMessage: 'Event log',
    },
    eventLogs: {
        id: 'event-logs',
        defaultMessage: 'Event logs',
    },
    payStations: {
        id: 'pay-stations',
        defaultMessage: 'Pay stations',
    },
    cardAPI: {
        id: 'card-api',
        defaultMessage: 'Card API',
    },
    cashAPI: {
        id: 'cash-api',
        defaultMessage: 'Cash API',
    },
    fiscalAPI: {
        id: 'fiscal-api',
        defaultMessage: 'Fiscal API',
    },
    backend: {
        id: 'backend',
        defaultMessage: 'Backend',
    },
    operationDashboard: {
        id: 'operation-dashboard',
        defaultMessage: 'Operation dashboard',
    },
    code: {
        id: 'code',
        defaultMessage: 'Code',
    },
    site: {
        id: 'site',
        defaultMessage: 'Site',
    },
    operational: {
        id: 'operational',
        defaultMessage: 'Operational',
    },
    warning: {
        id: 'warning',
        defaultMessage: 'Warning',
    },
    noConnection: {
        id: 'no-connection',
        defaultMessage: 'No connection',
    },
    createPayStationSuccess: {
        id: 'create-pay-station-success',
        defaultMessage: 'Pay station created',
    },
    createPayStationSuccessDescription: {
        id: 'create-pay-station-success-description',
        defaultMessage: 'Pay station {entry} has been successfully created.',
    },
    addPayStationSubtitle: {
        id: 'add-pay-station-subtitle',
        defaultMessage: 'Add new pay station',
    },
    deletePayStation: {
        id: 'delete-pay-station',
        defaultMessage: 'Delete pay station',
    },
    deletePayStationSuccess: {
        id: 'delete-pay-station-success',
        defaultMessage: 'Pay station deleted',
    },
    deletePayStationSuccessDescription: {
        id: 'delete-pay-station-success-description',
        defaultMessage: 'The pay station has been successfully deleted.',
    },
    deletePayStationSubtitle: {
        id: 'delete-pay-station-subtitle',
        defaultMessage: 'Permanently delete pay station',
    },
    confirmDeletePayStation: {
        id: 'confirm-delete-pay-station',
        defaultMessage: 'Are you sure you want to delete this pay station? This action cannot be undone.',
    },
    updatePayStationSuccess: {
        id: 'update-pay-station-success',
        defaultMessage: 'Pay station updated',
    },
    updatePayStationSuccessDescription: {
        id: 'update-pay-station-success-description',
        defaultMessage: 'Pay station {entry} has been successfully updated.',
    },
    editPayStationSubtitle: {
        id: 'edit-pay-station-subtitle',
        defaultMessage: 'Edit pay station {entry}',
    },
    nominalValue: {
        id: 'nominal-value',
        defaultMessage: 'Nominal value',
    },
    inRecycleBox: {
        id: 'in-recycle-box',
        defaultMessage: 'In recycle box',
    },
    cashLevels: {
        id: 'cash-levels',
        defaultMessage: 'Cash levels',
    },
    cashLevel: {
        id: 'cash-level',
        defaultMessage: 'Cash level',
    },
    count: {
        id: 'count',
        defaultMessage: 'Count',
    },
    cashTransactions: {
        id: 'cash-transactions',
        defaultMessage: 'Cash transactions',
    },
    cashTransaction: {
        id: 'cash-transaction',
        defaultMessage: 'Cash transaction',
    },
    payStationDashboard: {
        id: 'pay-station-dashboard',
        defaultMessage: 'Pay station dashboard',
    },
    servicePassword: {
        id: 'service-password',
        defaultMessage: 'Service password',
    },
    languages: {
        id: 'languages',
        defaultMessage: 'Languages',
    },
    defaultLanguage: {
        id: 'default-language',
        defaultMessage: 'Default language',
    },
    currencies: {
        id: 'currencies',
        defaultMessage: 'Currencies',
    },
    lostTicket: {
        id: 'lost-ticket',
        defaultMessage: 'Lost ticket',
    },
    webId: {
        id: 'web-id',
        defaultMessage: 'Web id',
    },
    homeQR: {
        id: 'home-q-r',
        defaultMessage: 'Home QR',
    },
    homePayTextBG: {
        id: 'home-pay-text-bg',
        defaultMessage: 'Home pay text (BG)',
    },
    homePayTextEN: {
        id: 'home-pay-text-en',
        defaultMessage: 'Home pay text (EN)',
    },
    supportPhone: {
        id: 'support-phone',
        defaultMessage: 'Support phone',
    },
    enablePaymentMethods: {
        id: 'enable-payment-methods',
        defaultMessage: 'Enable payment methods',
    },
    enableSettingsEnter: {
        id: 'enable-settings-enter',
        defaultMessage: 'Enable settings enter',
    },
    enableSubscription: {
        id: 'enable-subscription',
        defaultMessage: 'Enable subscription',
    },
    enableFreeStay: {
        id: 'enable-free-stay',
        defaultMessage: 'Enable free stay',
    },
    coinAcceptedNominals: {
        id: 'coin-accepted-nominals',
        defaultMessage: 'Coin accepted nominals',
    },
    coinPayoutNominals: {
        id: 'coin-payout-nominals',
        defaultMessage: 'Coin payout nominals',
    },
    banknoteAcceptedNominals: {
        id: 'banknote-accepted-nominals',
        defaultMessage: 'Banknote accepted nominals',
    },
    banknotePayoutNominals: {
        id: 'banknote-payout-nominals',
        defaultMessage: 'Banknote payout nominals',
    },
    createdAt: {
        id: 'created-at',
        defaultMessage: 'Created at',
    },
    bulgarian: {
        id: 'bulgarian',
        defaultMessage: 'Bulgarian',
    },
    english: {
        id: 'english',
        defaultMessage: 'English',
    },
    enable: {
        id: 'enable',
        defaultMessage: 'Enable',
    },
    addCoinAcceptedNominals: {
        id: 'add-coin-accepted-nominals',
        defaultMessage: 'Add coin accepted nominals',
    },
    addCoinPayoutNominals: {
        id: 'add-coin-payout-nominals',
        defaultMessage: 'Add coin payout nominals',
    },
    addBanknoteAcceptedNominals: {
        id: 'add-banknote-accepted-nominals',
        defaultMessage: 'Add banknote accepted nominals',
    },
    addBanknotePayoutNominals: {
        id: 'add-banknote-payout-nominals',
        defaultMessage: 'Add banknote payout nominals',
    },
    address: {
        id: 'address',
        defaultMessage: 'Address',
    },
    operationalErrors: {
        id: 'operational-errors',
        defaultMessage: 'Operational errors',
    },
    defaultCode: {
        id: 'default-code',
        defaultMessage: 'Default code',
    },
    defaultDetail: {
        id: 'default-detail',
        defaultMessage: 'Default detail',
    },
    statusCode: {
        id: 'status-code',
        defaultMessage: 'Status code',
    },
    denomination: {
        id: 'denomination',
        defaultMessage: 'Denomination',
    },
    transactionNumber: {
        id: 'transaction-number',
        defaultMessage: 'Transaction number',
    },
    object: {
        id: 'object',
        defaultMessage: 'Object',
    },
    cardTransactions: {
        id: 'card-transactions',
        defaultMessage: 'Card transactions',
    },
    cardTransaction: {
        id: 'card-transaction',
        defaultMessage: 'Card transaction',
    },
    insert: {
        id: 'insert',
        defaultMessage: 'Insert',
    },
    dispense: {
        id: 'dispense',
        defaultMessage: 'Dispense',
    },
    fail: {
        id: 'fail',
        defaultMessage: 'Fail',
    },
    reverse: {
        id: 'reverse',
        defaultMessage: 'Reverse',
    },
    reverseFail: {
        id: 'reverse-fail',
        defaultMessage: 'Reverse fail',
    },
    cancel: {
        id: 'cancel',
        defaultMessage: 'Cancel',
    },
    recycleBoxTransfers: {
        id: 'recycle-box-transfers',
        defaultMessage: 'Recycle box transfers',
    },
    recycleBoxTransfer: {
        id: 'recycle-box-transfer',
        defaultMessage: 'Recycle box transfer',
    },
    manualDispenseCoins: {
        id: 'manual-dispense-coins',
        defaultMessage: 'Manual dispense coins',
    },
    manualDispenseBanknotes: {
        id: 'manual-dispense-banknotes',
        defaultMessage: 'Manual dispense banknotes',
    },
    clearCoins: {
        id: 'clear-coins',
        defaultMessage: 'Clear coins',
    },
    clearBanknotes: {
        id: 'clear-banknotes',
        defaultMessage: 'Clear banknotes',
    },
    issuingFiscalNoteFailed: {
        id: 'issuing-fiscal-note-failed',
        defaultMessage: 'Issuing fiscal note failed',
    },
    issuingFiscalNoteCompletedReturnAmountFailed: {
        id: 'issuing-fiscal-note-completed-return-amount-failed',
        defaultMessage: 'Issuing fiscal note completed return amount failed',
    },
    issuingFiscalNoteFailedReturnAmountFailed: {
        id: 'issuing-fiscal-note-failed-return-amount-failed',
        defaultMessage: 'Issuing fiscal note failed return amount failed',
    },
    issuingFiscalNoteFailedReverseTransactionFailed: {
        id: 'issuing-fiscal-note-failed-reverse-transaction-failed',
        defaultMessage: 'Issuing fiscal note failed reverse transaction failed',
    },
    issuingFiscalNoteReverseTransactionFailed: {
        id: 'issuing-fiscal-note-reverse-transaction-failed',
        defaultMessage: 'Issuing fiscal note reverse transaction failed',
    },
    initializeReverseIssuingFiscalNoteFailed: {
        id: 'initialize-reverse-issuing-fiscal-note-failed',
        defaultMessage: 'Initialize reverse issuing fiscal note failed',
    },
    initializeReversalIssuingFiscalNoteCompleted: {
        id: 'initialize-reversal-issuing-fiscal-note-completed',
        defaultMessage: 'Initialize reversal issuing fiscal note completed',
    },
    dispenseAmountWithIssueFiscalNoteFailed: {
        id: 'dispense-amount-with-issue-fiscal-note-failed',
        defaultMessage: 'Dispense amount with issue fiscal note failed',
    },
    dispenseAmountWithIssueFiscalNoteCompleted: {
        id: 'dispense-amount-with-issue-fiscal-note-completed',
        defaultMessage: 'Dispense amount with issue fiscal note completed',
    },
    cancelledInsertingAmountReturnedAmountFailed: {
        id: 'cancelled-inserting-amount-returned-amount-failed',
        defaultMessage: 'Cancelled inserting amount returned amount failed',
    },
    initializeReverseIssuingFiscalNoteReverseTransactionFailed: {
        id: 'initialize-reverse-issuing-fiscal-note-reverse-transaction-failed',
        defaultMessage: 'Initialize reverse issuing fiscal note reverse transaction failed',
    },
    dispensingAmountCancelledInsertingAmount: {
        id: 'dispensing-amount-cancelled-inserting-amount',
        defaultMessage: 'Dispensing amount cancelled inserting amount',
    },
    cancelledInsertingAmountReturnedAmountSuccessful: {
        id: 'cancelled-inserting-amount-returned-amount-successful',
        defaultMessage: 'Cancelled inserting amount returned amount successful',
    },
    issuingFiscalNoteFailedReturnAmountSuccessful: {
        id: 'issuing-fiscal-note-failed-return-amount-successful',
        defaultMessage: 'Issuing fiscal note failed returned amount successful',
    },
    issuingFiscalNoteCompletedReturnAmountSuccessful: {
        id: 'issuing-fiscal-note-completed-return-amount-successful',
        defaultMessage: 'Issuing fiscal note completed returned amount successful',
    },
    issuingFiscalNoteFailedReverseTransactionSuccessful: {
        id: 'issuing-fiscal-note-failed-reverse-transaction-successful',
        defaultMessage: 'Issuing fiscal note failed reverse transaction successful',
    },
    issuingFiscalNoteReverseTransactionSuccessful: {
        id: 'issuing-fiscal-note-reverse-transaction-successful',
        defaultMessage: 'Issuing fiscal note reverse transaction successful',
    },
    initializeReversalIssuingFiscalNoteReverseTransactionSuccessful: {
        id: 'initialize-reversal-issuing-fiscal-note-reverse-transaction-successful',
        defaultMessage: 'Initialize reversal issuing fiscal note reverse transaction successful',
    },
    dispenseAmountWithIssueFiscalNote: {
        id: 'dispense-amount-with-issue-fiscal-note',
        defaultMessage: 'Dispense amount with issue fiscal note',
    },
    initializeReversalIssuingFiscalNote: {
        id: 'initialize-reversal-issuing-fiscal-note',
        defaultMessage: 'Initialize reversal issuing fiscal note',
    },
    digitalReceipt: {
        id: 'digital-receipt',
        defaultMessage: 'Digital receipt',
    },
    downloadCopyDescription: {
        id: 'download-copy-description',
        defaultMessage: 'Download a copy of the receipt, as it would have appeared on paper.',
    },
    viewReceipt: {
        id: 'view-receipt',
        defaultMessage: 'View receipt',
    },
    uiModel: {
        id: 'ui-model',
        defaultMessage: 'UI model',
    },
    backendUrl: {
        id: 'backend-url',
        defaultMessage: 'Backend URL',
    },
    backendApiKey: {
        id: 'backend-api-key',
        defaultMessage: 'Backend API key',
    },
    interactive: {
        id: 'interactive',
        defaultMessage: 'Interactive',
    },
    unattended: {
        id: 'unattended',
        defaultMessage: 'Unattended',
    },
    readOnlyDisplay: {
        id: 'read-only display',
        defaultMessage: 'Read only display',
    },
    pipelineProfile: {
        id: 'pipeline-profile',
        defaultMessage: 'Pipeline profile',
    },
    bgWithFiscalisation: {
        id: 'bg-with-fiscalisation',
        defaultMessage: 'With fiscalisation (BG)',
    },
    bgWithoutFiscalisation: {
        id: 'bg-without-fiscalisation',
        defaultMessage: 'Without fiscalisation (BG)',
    },
    generateNewApiKey: {
        id: 'generate-new-api-key',
        defaultMessage: 'Generate new API key',
    },
    confirmGenerateNewApiKey: {
        id: 'confirm-generate-new-api-key',
        defaultMessage: 'Are you sure you want to generate new API key?',
    },
    generateNewApiKeyDescription: {
        id: 'generate-new-api-key-description',
        defaultMessage: 'Generating a new API key will invalidate your previous key',
    },
    continue: {
        id: 'continue',
        defaultMessage: 'Continue',
    },
    copyGeneratedApiKey: {
        id: 'copy-generated-api-key',
        defaultMessage: "Copy the generated API key. You won't be able to access it again: <b>{key}</b>",
    },
    copyApiKey: {
        id: 'copy-api-key',
        defaultMessage: 'Copy the API key',
    },
    clearBanknoteLevels: {
        id: 'clear-banknote-levels',
        defaultMessage: 'Clear banknote levels',
    },
    clearBanknoteLevelsDescription: {
        id: 'clear-banknote-levels-description',
        defaultMessage: 'Clear banknote levels for {payStation}',
    },
    confirmClearBanknoteLevels: {
        id: 'confirm-clear-banknote-levels',
        defaultMessage:
            'Are you sure you want to clear banknote levels for {payStation}? This action cannot be undone.',
    },
    clearBanknoteLevelsSuccess: {
        id: 'clear-banknote-levels-success',
        defaultMessage: 'Banknote levels updated',
    },
    clearBanknoteLevelsSuccessDescription: {
        id: 'clear-banknote-levels-success-description',
        defaultMessage: 'The banknote levels for {payStation} have been successfully cleared.',
    },
    clearCoinLevels: {
        id: 'clear-coin-levels',
        defaultMessage: 'Clear coin levels',
    },
    clearCoinLevelsDescription: {
        id: 'clear-coin-levels-description',
        defaultMessage: 'Clear coin levels for {payStation}',
    },
    confirmClearCoinLevels: {
        id: 'confirm-clear-coin-levels',
        defaultMessage: 'Are you sure you want to clear coin levels for {payStation}? This action cannot be undone.',
    },
    clearCoinLevelsSuccess: {
        id: 'clear-coin-levels-success',
        defaultMessage: 'Coin levels updated',
    },
    clearCoinLevelsSuccessDescription: {
        id: 'clear-coin-levels-success-description',
        defaultMessage: 'The coin levels for {payStation} have been successfully cleared.',
    },
    actions: {
        id: 'actions',
        defaultMessage: 'Actions',
    },
    payStationActions: {
        id: 'pay-station-actions',
        defaultMessage: 'Pay station actions',
    },
    changeCoinBanknoteAvailability: {
        id: 'change-coin-banknote-availability',
        defaultMessage: 'Change cash levels',
    },
    changeCoinBanknoteAvailabilitySubtitle: {
        id: 'change-coin-banknote-availability-subtitle',
        defaultMessage: 'Change the cash levels for {payStation}',
    },
    coins: {
        id: 'coins',
        defaultMessage: 'Coins',
    },
    banknotes: {
        id: 'banknotes',
        defaultMessage: 'Banknotes',
    },
    cashLevelsChangedSuccess: {
        id: 'cash-levels-changed-success',
        defaultMessage: 'Cash levels changed',
    },
    cashLevelsChangedSuccessDescription: {
        id: 'cash-levels-changed-success-description',
        defaultMessage: 'The cash levels for {payStation} has been successfully updated.',
    },
    clearLevels: {
        id: 'clear-levels',
        defaultMessage: 'Clear',
    },
    subscriptionPaymentCash: {
        id: 'subscription-payment-cash',
        defaultMessage: 'Subscription cash payment',
    },
    subscriptionPaymentCard: {
        id: 'subscription-payment-card',
        defaultMessage: 'Subscription card payment',
    },
});
